/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Информация по картинке.
 */
export interface PhotoInfo { 
    /**
     * Наименоваине файла.
     */
    fileName?: string;
    /**
     * Идентификатор.
     */
    id?: string;
    /**
     * Статус.
     */
    status?: number;
    /**
     * Идентификатор сущности.
     */
    attachId?: string;
    /**
     * Описание.
     */
    description?: string;
    /**
     * Признак обложки.
     */
    isCover?: boolean;
}

